/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/21
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

const STORAGE_KEY = 'vega.state.slack.user.scopes';
let storedState = localStorage.getItem(STORAGE_KEY);
const initialState: string[] = storedState ? JSON.parse(storedState) : [];

export const slice = createSlice({
	name: 'slack-user-token-scopes',
	initialState,
	reducers: {
		set: (state, action: PayloadAction<string[]>) => {
			const newState = action.payload;
			persistState(STORAGE_KEY, newState);
			return newState;
		},
		add: (state, action: PayloadAction<string[]>) => {
			const newState = [ ...state, ...action.payload.filter(s => !state.includes(s)) ];
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const { set, add } = slice.actions;
export default slice.reducer;